import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import * as CryptoJS from "crypto-js";
import { environment } from '../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  apiUrl = environment.API_URL;
  public static SECRET_KEY: any = "5fc6801bada241b3";

  constructor(private http: HttpClient) { }
  //Encryption
  encryptText(value: any, secretkey: any) {
    let key = CryptoJS.enc.Utf8.parse(secretkey);
    let iv = CryptoJS.enc.Utf8.parse(secretkey);
    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  }

  //Decryption
  decryptText(value: any, secretkey: any) {
    let key = CryptoJS.enc.Utf8.parse(secretkey);
    let iv = CryptoJS.enc.Utf8.parse(secretkey);
    let decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  sendPostRequest(data: Object): Observable<Object> {
    return this.http.post(this.apiUrl, data);
  }
  public getIPAddress() {
    return this.http.get("https://api.ipify.org/?format=json");
  }
  postAPI(url: any, postData: any): Promise<any> {
    // console.log(url, "URL");
    // console.log(url, "postData")
    const httpOptions: Object = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "X-Content-Type-Options": "nosniff",
      }),
      responseType: "text",
    };

    return new Promise((resolve, reject) => {
      this.http.post(url, postData, httpOptions).subscribe(
        (result) => {
          resolve(JSON.parse(JSON.stringify(result)));
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  postAPIMethod(url: any, postData: any): Observable<any> {

    const httpOptions: Object = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "X-Content-Type-Options": "nosniff",
      }),
      responseType: "text",
    };

    return this.http.post(url, postData, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.log(error)
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  };

  getAPI(url: any): Promise<any> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     "Content-Type": "application/json",
    //     "X-Content-Type-Options": "nosniff",
    //   }),
    //   responseType: "text",
    // };


    const httpOptions: Object = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "X-Content-Type-Options": "nosniff",
      }),
      responseType: "text",
    };

    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(
        (result) => {
          resolve(JSON.parse(JSON.stringify(result)));
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
